import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './index.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import Instructions from './components/Instructions';
import Gallery from './components/Gallery';
import Community from './components/Community';
import Telegram from './components/Telegram';
import GDPRBanner from './components/GDPRBanner';

function App() {
  return (
    <Router>
      <div className="App">
        <GDPRBanner />
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/instructions" element={<Instructions />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/community" element={<Community />} />
            <Route path="/telegram" element={<Telegram />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 